var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type * 1 === 1)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.info))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }